import React, { Component } from 'react'
import {View, Platform, StyleSheet} from 'react-native'
import {JDText, JDDevice, MapView, JDImage, JDTouchable, JDMta, JDToast} from '@jdreact/jdreact-core-lib'
import PropTypes from "prop-types"
import PageContainer from "../../components/PageContainer"
import MapWeb from "../../components/ThumbnailMap/MapWeb"
import * as api from '../../utils/api'
import * as tools from "../../utils/tools"
import * as businessMethods from "../../utils/businessMethods"
import { toCallPhone } from "../../utils/callPhone"
import telCallIcon from '../../images/detail/tell_buttonnew.png'

const locationImg = 'https://img13.360buyimg.com/imagetools/jfs/t1/150814/37/1652/1994/5f6ee80dE1aedb5c6/bda8f807c78a3b06.png'
const LATITUDE_DELTA = 0.01351351
const LONGITUDE_DELTA = 0.01351351

export default class ShopMap extends Component {
	static contextTypes = {
		router: PropTypes.object
	}

	constructor(props) {
		super(props)
		this.state = {
			houseShopInfo: {}, // 门店信息
			isShowErrMsg: false,
			errMsg: ''
		}
	}

	componentDidMount() {
		const { primaryKey, shopLat, shopLon } = this.props
		if(!primaryKey) return
		if (shopLat && shopLon) {
		  this.setState({
				shopLat: parseFloat(shopLat, 10),
				shopLon: parseFloat(shopLon, 10)
		  })
		}
		api.getDetailHouseData({
			primaryKey:  primaryKey
		}).then((res) => {
			let pageParam = ''
			if (res && res.code == 0) {
				let { houseStoreDTO } = res // 门店信息
				const houseShopInfo = businessMethods.getProcessedHouseShopInfo(houseStoreDTO) || {}
				const { storeId, latLon } = houseShopInfo
				const { lat, lon }  = latLon || {}
				const { shopLat, shopLon } = this.state
				this.setState({
					houseShopInfo,
					shopLat: shopLat || lat,
					shopLon: shopLon || lon
				})
				pageParam = storeId
			} else {
				const errMsg = (res || {}).errorMsg || '网络不好哦！'
				this.setState({
					isShowErrMsg: true,
					errMsg
				})
			}
			JDMta.isReportDefaultPageParam = false
			JDMta.sendPvData('', `${pageParam}`, 'SHouse_ShopDetail')
		}).catch((err) => {
		  console.log(err, 'queryHouseResourceDetail err!')
			this.setState({
				isShowErrMsg: true,
				errMsg: '网络不好哦！'
			})
			JDMta.sendPvData('', '', 'SHouse_ShopDetail')
		})
	}

	telCall = () => {
		const { storePhone, storeId } = this.state.houseShopInfo || {}
		if (storePhone) { toCallPhone(storePhone) }
		JDMta.sendClickData('SHouse_ShopTel', `${storeId}`, '','',	'', '', 'SHouse_ShopDetail', '');
	}

	// 渲染地图
	renderMap = (shopLat, shopLon) => {
		if (Platform.OS == 'web') { // web端
			return (
				<MapWeb
					mapStyle={{height: JDDevice.height}}
					addressLat={shopLat} addressLon={shopLon} zoom={15}/>
			)
		} else {
			return (
				<MapView
					provider={this.props.provider}
					style={shopMapStyles.map}
					mapType={MapView.MAP_TYPES.STANDARD}
					initialRegion={{
						latitude: shopLat,
						longitude: shopLon,
						latitudeDelta: LATITUDE_DELTA,
						longitudeDelta: LONGITUDE_DELTA,
					}}
				>
					<MapView.Marker
						coordinate={{
							latitude: shopLat,
							longitude: shopLon,
						}}
						image={locationImg}
					>
					</MapView.Marker>
				</MapView>
			)
		}
	}
	// 隐藏错误提示
	hideToast = () => {
		this.setState({
			errMsg: null,
			isShowErrMsg: false
		})
	}

	render() {
		const { houseShopInfo, shopLat, shopLon, isShowErrMsg, errMsg } = this.state
		const storeName = (houseShopInfo || {}).storeName || null
		const titleName = storeName ? storeName.slice(0, 11) + '...' : '京东二手房'
		return (
			<PageContainer title={titleName} style={shopMapStyles.mapPageContainer}>
				{
					shopLat && shopLon && this.renderMap(shopLat, shopLon)
				}
				{
					storeName && (
						<View style={[shopMapStyles.shopContent, (tools.isPhoneX()) ? {bottom: JDDevice.getRpx(55)} : null]}>
							<JDText style={shopMapStyles.shopTitle} numberOfLines={1}>{storeName || ''}</JDText>
							<View style={shopMapStyles.shopInfo}>
								<View style={shopMapStyles.shopInfoInner}>
									{
										houseShopInfo.bussinessTimeStr ? (
											<View style={shopMapStyles.shopRow}>
												<JDText style={shopMapStyles.shopRowLabel}>营业时间</JDText>
												<JDText style={shopMapStyles.shopRowInfo}>{houseShopInfo.bussinessTimeStr}</JDText>
											</View>
										) : null
									}
									{
										houseShopInfo.storeAddress ? (
											<View style={[shopMapStyles.shopRow, {marginTop: JDDevice.getRpx(16)}]}>
											{/*<View style={shopMapStyles.shopRow}>*/}
												<JDText style={shopMapStyles.shopRowLabel}>门店地址</JDText>
												<JDText style={shopMapStyles.shopRowInfo}>{houseShopInfo.storeAddress || ''}</JDText>
											</View>
										) : null
									}
								</View>
								{
									houseShopInfo.storePhone ? (
										<JDTouchable style={shopMapStyles.telCallCon} onPress={this.telCall}>
											<JDImage style={shopMapStyles.telCallIcon} source={telCallIcon}></JDImage>
										</JDTouchable>
									) : null
								}
							</View>
						</View>
					)
				}
				{/*错误信息提示模块*/}
				<JDToast show={isShowErrMsg} onHide={this.hideToast} style={shopMapStyles.toastStyle} mode={JDToast.MODE.MODAL}>
					{ errMsg }
				</JDToast>
			</PageContainer>
		)
	}
}

const shopMapStyles = StyleSheet.create({
	mapPageContainer: {
		position: 'relative'
	},
	map: {
		height: JDDevice.height
	},
	shopContent: {
		position: 'absolute',
		bottom: JDDevice.getRpx(21),
		marginHorizontal: JDDevice.getRpx(24),
		paddingTop: JDDevice.getRpx(32),
		paddingRight: JDDevice.getRpx(120),
		paddingBottom: JDDevice.getRpx(32),
		paddingLeft: JDDevice.getRpx(30),
		width: JDDevice.getRpx(702),
		borderRadius: JDDevice.getRpx(16),
		backgroundColor: '#fff',
		...Platform.select({ // 不同的平台执行不同的阴影样式
			ios: {
				shadowColor: '#000',
				shadowOffset: {h: 0, w: JDDevice.getRpx(10)}, // ios设置阴影
				shadowOpacity: 0.1
			},
			web: {
				boxShadow: '0 0 5px 0 rgba(0,0,0,0.1)'
			}
		}),
	},
	shopTitle: {
		fontSize: JDDevice.getFontSize(32),
		fontWeight: 'bold',
		color: '#424854',
		lineHeight: JDDevice.getRpx(38),
		marginBottom: JDDevice.getRpx(24)
	},
	shopInfo: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		width: JDDevice.getRpx(642),
	},
	shopInfoInner: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		flex: 1,
	},
	shopRow: {
		display: 'flex',
		flexDirection: 'row',
		fontSize: JDDevice.getRpx(24),
		color: '#424854'
	},
	shopRowLabel: {
		marginRight: JDDevice.getRpx(10),
		paddingHorizontal: JDDevice.getRpx(10),
		height: JDDevice.getRpx(32),
		lineHeight: JDDevice.getRpx(32),
		fontSize: JDDevice.getRpx(24),
		color: '#848689',
		backgroundColor: '#F0F2F5',
		borderRadius: JDDevice.getRpx(4),

	},
	shopRowInfo: {
		flex: 1,
		lineHeight: JDDevice.getRpx(32),
		fontSize: JDDevice.getRpx(24),
		color: '#424854'
	},
	telCallCon: {
		width: JDDevice.getRpx(74),
		height: JDDevice.getRpx(74)
	},
	telCallIcon: {
		marginTop: JDDevice.getRpx(10),
		marginLeft: JDDevice.getRpx(10),
		width: JDDevice.getRpx(52),
		height: JDDevice.getRpx(52),
	},
	toastStyle: {
		backgroundColor: 'rgba(0,0,0,0.6)'
	}
})
